// @flow
// Used for the Terminal IB to determine which PMs to use
import type {TerminalCountry} from 'docs/data/integration-builder';

const stringsWithSpaces = (
  pms: Array<string>,
  spaces: number,
  doubleQuote = false,
) =>
  pms.map(
    (pm) =>
      `${new Array(spaces).fill(' ').join('')}${doubleQuote ? '"' : "'"}${pm}${
        doubleQuote ? '"' : "'"
      },`,
  );

const java = (pms) =>
  pms.map(
    (pm) => `${new Array(8).fill(' ').join('')}.addPaymentMethodType("${pm}")`,
  );

export const formatTerminalPaymentMethods = (
  language: ?string,
  country: ?TerminalCountry,
): Array<string> => {
  const pms =
    country === 'CA' ? ['card_present', 'interac_present'] : ['card_present'];

  switch (language) {
    case 'ruby':
    case 'python':
    case 'php':
    case 'javascript':
      return stringsWithSpaces(pms, 6);
    case 'csharp':
      return stringsWithSpaces(pms, 12, true);
    case 'go':
      return stringsWithSpaces(pms, 6, true);
    case 'java':
      return java(pms);
    case 'objectivec':
      return pms.map((pm) => `@"${pm}"`);
    case 'javaclient':
      return pms.map((pm) => `PaymentMethodType.${pm.toUpperCase()}`);
    case 'swift':
    case 'kotlin':
      return pms.map((pm) => `"${pm}"`);
    default:
      return [''];
  }
};
